import { __assign, __extends } from "tslib";
import { ScrollView, Text, View } from 'react-native';
import React from 'react';
import { textStyle } from './v2/theme';
import { connect } from './redux';
function withPnmacTitle(WrappedComponent, createTitle, haveConnect) {
  if (haveConnect === void 0) {
    haveConnect = true;
  }
  if (haveConnect) {
    return /** @class */function (_super) {
      __extends(class_1, _super);
      function class_1() {
        return _super !== null && _super.apply(this, arguments) || this;
      }
      class_1.prototype.render = function () {
        var _a, _b;
        return /*#__PURE__*/React.createElement(ScrollView, null, (createTitle === null || createTitle === void 0 ? void 0 : createTitle(__assign({}, this.props))) && /*#__PURE__*/React.createElement(View, {
          testID: "pageBubble",
          accessible: true,
          accessibilityRole: 'text',
          accessibilityLabel: (_a = createTitle === null || createTitle === void 0 ? void 0 : createTitle(this.props)) !== null && _a !== void 0 ? _a : '',
          style: {
            margin: 20
          }
        }, /*#__PURE__*/React.createElement(Text, {
          style: textStyle.pageTitle
        }, (_b = createTitle === null || createTitle === void 0 ? void 0 : createTitle(__assign({}, this.props))) !== null && _b !== void 0 ? _b : '')), /*#__PURE__*/React.createElement(WrappedComponent, __assign({}, this.props)));
      };
      return class_1;
    }(React.Component);
  }
  return connect(function (state) {
    return {
      translations: state.translations
    };
  })(/** @class */function (_super) {
    __extends(class_2, _super);
    function class_2() {
      return _super !== null && _super.apply(this, arguments) || this;
    }
    class_2.prototype.render = function () {
      var _a, _b;
      return /*#__PURE__*/React.createElement(ScrollView, null, /*#__PURE__*/React.createElement(View, {
        testID: "pageBubble",
        accessible: true,
        accessibilityRole: 'text',
        accessibilityLabel: (_a = createTitle === null || createTitle === void 0 ? void 0 : createTitle(this.props)) !== null && _a !== void 0 ? _a : '',
        style: {
          margin: 20
        }
      }, /*#__PURE__*/React.createElement(Text, {
        style: textStyle.pageTitle
      }, (_b = createTitle === null || createTitle === void 0 ? void 0 : createTitle(__assign({}, this.props))) !== null && _b !== void 0 ? _b : '')), /*#__PURE__*/React.createElement(WrappedComponent, __assign({}, this.props)));
    };
    return class_2;
  }(React.Component));
}
export default withPnmacTitle;